/**
 * Look-at target meaning "No one": the actor stops looking (head and whole body).
 * An empty target is different: it keeps whatever the actor was looking at.
 */
export const NO_LOOKAT = "none";

export const isNoLookat = (target?: string) => target === NO_LOOKAT;

/** A real actor, prop or position to look at: not empty and not "No one". */
export const hasLookatTarget = (target?: string) => !!target && target !== NO_LOOKAT;
